import { render } from "./transfer.vue?vue&type=template&id=d546ab24&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=d546ab24&lang=scss&scoped=true"
import "./transfer.vue?vue&type=style&index=1&id=d546ab24&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d546ab24"]])

export default __exports__